export const AFT_ONLY_SUFFIX = "(AFT Org Only)";

export const LEADERSHIP_PAGE_TITLE = `Leadership Risk ${AFT_ONLY_SUFFIX}`;

export const LEADERSHIP_NAV_TITLE = `Leadership Dashboard ${AFT_ONLY_SUFFIX}`;

export const LEADERSHIP_OTHER_ORGS_MESSAGE =
    "The leadership dashboard currently covers the AFT org only. " +
    "Support for other orgs is coming soon.";

export const TEAMS_RECORD_URL = "https://permissions.amazon.com/";

export const DEFAULT_CR_LIMIT = 5;

export interface MonitorSchedule {
    readonly refreshes: string;
    readonly cadence: string;
    readonly detail: string;
}

export const MONITOR_SCHEDULES: readonly MonitorSchedule[] = [
    {
        refreshes: "Packages for your pipelines",
        cadence: "Weekly — Monday 00:00 UTC",
        detail:
            "Scans each onboarded pipeline and records the packages it builds, " +
            "along with version set and branch information.",
    },
    {
        refreshes: "Dependencies and their guidance",
        cadence: "Twice weekly — Monday and Thursday 02:00 UTC",
        detail:
            "Collects the dependencies of every known package and the current " +
            "vendor guidance for each one.",
    },
    {
        refreshes: "New code reviews",
        cadence: "Daily — 04:00 UTC",
        detail:
            "Raises code reviews for dependencies that have a recommended upgrade, " +
            "up to your team's code review limit.",
    },
    {
        refreshes: "Code review status",
        cadence: "Continuously, as reviews change",
        detail:
            "Updates a code review's state on this site shortly after it is raised, " +
            "merged, or closed. This is not on a schedule.",
    },
];
